import { render, staticRenderFns } from "./nicknameModal.vue?vue&type=template&id=2a04cf52&lang=pug&"
import script from "./nicknameModal.vue?vue&type=script&lang=js&"
export * from "./nicknameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports